<ul>
    <ng-container *ngFor="let item of links | keyvalue">
        <li class="menu-item" *ngIf="item.value && propertyMap[item.key] as properties">
            <span class="link">
                <app-link [label]="properties.translation | translateSafe"
                          [link]="{ url: item.value, target: '_blank' }">
                    <app-svg-icon [iconName]="properties.icon"></app-svg-icon>
                    <span class="kk-visuallyhidden">
                        {{ properties.translation | translateSafe }}
                    </span>
                </app-link>
            </span>
        </li>
    </ng-container>
</ul>
